<template>
    <div>

        <rkm-row
            v-for="(agendamento, index) in itemsNotRealizados"
            :key="index"
        >

            <rkm-col
                class="mb-2"
                cols="12"
            >

                <rkm-list-group>
                    <rkm-list-group-item
                        class="rkm-list-group-item pr-0 pl-1"
                    >

                        <rkm-row>

                            <rkm-col class="flex-grow-1">
                                <h4 class="mb-0">{{ agendamento.pacienteNome }}</h4>
                                <h4 class="mb-0" v-if="agendamento.pacientePreferenciaNome">
                                    <strong>({{ agendamento.pacienteNomeSocial }})</strong>
                                </h4>
                            </rkm-col>

                            <rkm-col cols="auto">
                                <rkm-button
                                    @click="handleReagendar(agendamento)"
                                    color="primary"
                                    small
                                >
                                    Reagendar coleta
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row class="font-13">
                            <rkm-col cols="3">
                                <strong>Idade:</strong> {{ agendamento.pacienteIdade }}
                            </rkm-col>

                            <rkm-col cols="3">
                                <strong>Data de nascimento:</strong> {{ agendamento.pacienteNascimento }}
                            </rkm-col>

                            <rkm-col cols="3">
                                <strong>Prontuário:</strong> {{ agendamento.pacienteProntuario }}
                            </rkm-col>

                            <rkm-col cols="3">
                                <strong>Raça/Cor:</strong> {{ agendamento.cidadaoRacaCor }}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row class="font-13">
                            <rkm-col cols="6">
                                <strong>Unidade solicitante:</strong> {{ agendamento.unidadeNome }}
                            </rkm-col>

                            <rkm-col cols="6">
                                <strong>Local de atendimento:</strong> {{ agendamento.infraestruturaNome }}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row class="font-13">
                            <rkm-col cols="6">
                                <strong>Médico solicitante:</strong> {{ agendamento.medicoNome }}
                            </rkm-col>

                            <rkm-col>
                                <strong>Protocolo:</strong> {{ agendamento.agendamentoNumero }}
                            </rkm-col>
                        </rkm-row>
                    </rkm-list-group-item>
                </rkm-list-group>

                <rkm-collapse
                    class="rkm-collapse"
                    visible
                >

                    <rkm-row class="p-2">
                        <rkm-col cols="12">

                            <rkm-table
                                :items="agendamento.exames"
                                :fields="fields"
                                hide-filters
                                sort-by="data"
                                :sort-compare="sortCompare"
                                hide-pagination
                            >

                                <template v-slot:cell(exameGrupoNome)="{ item }">
                                    {{item.exameGrupoNome}} {{ item.pertenceGrupo ? `(${item.nomesExame})` : ''}}
                                </template>

                                <template v-slot:cell(actions)="{ item }">

                                    <rkm-button
                                        color="primary"
                                        small
                                        title="Reagendar exame"
                                        @click.stop="handleStatus(agendamento, item)"
                                    >
                                        <rkm-icon icon="clone" />
                                    </rkm-button>
                                </template>
                            </rkm-table>
                        </rkm-col>
                    </rkm-row>
                </rkm-collapse>
            </rkm-col>
        </rkm-row>

        <ModalAgendamentoExameLaboratorial
            v-if="modalPacienteId && reagendar"
            :paciente-id="modalPacienteId"
            :reagendar="reagendar"
            :hasPrint="true"
            hide-agendamentos
            ref="ModalAgendamentoExameLaboratorial"
        />
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, object, formats, data, stringCase } from '@/mixins'

// Components.
import ModalAgendamentoExameLaboratorial from '@/components/exame-laboratorial/agendamento-exame/Modal'

// Moment.
import moment from 'moment'

// Enums.
import statusAgendamento from '@/enums/exame-laboratorial/statusAgendamento'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'
import racaCor from '@/enums/cadastro/cidadao/racaCor'

export default {
    components: { ModalAgendamentoExameLaboratorial },
    computed: {
        fields() {
            const fields = [
                {
                    key: "exameGrupoNome",
                    label: "Exame / Grupo",
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min text-center'
                }
            ]

            return fields
        },
    },
    data() {
        return {
            enums: {
                statusAgendamento,
                preferenciaNome,
                racaCor
            },
            modalPacienteId: null,
            reagendar: null,
        }
    },
    mixins: [repository, error, object, formats, data, stringCase],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        sortCompare(a, b, key) {

            if (key === 'data') {

                const dateA = moment(a[key], 'DD/MM/YYYY HH:mm')
                const dateB = moment(b[key], 'DD/MM/YYYY HH:mm')

                if (dateA > dateB) return 1
                else if (dateA < dateB) return -1
                else return 0

            } else {

                return false
            }
        },
        handleStatus(agendamento, item) {

            const exame = {
                ...agendamento,
                exames: [item]
            };

            this.modalPacienteId = agendamento.pacienteId
            this.reagendar = exame

            this.showConfirmation(
                `Deseja reagendar a coleta para o exame/grupo <strong>${item.exameGrupoNome}</strong>?`,
                async () => this.$nextTick().then(() => this.$refs.ModalAgendamentoExameLaboratorial.open())
            )
        },
        handleReagendar(agendamento) {

            const exame = this.clone(agendamento)

            this.modalPacienteId = exame.pacienteId
            this.reagendar = exame
            this.reagendar.exames = exame.exames.filter(exame => exame.statusId != this.enums.statusAgendamento.REALIZADO
                && exame.statusId != this.enums.statusAgendamento.AGENDADO
            )

            this.showConfirmation(
                `Deseja reagendar a coleta para o exames não realizados do protocolo <strong>${exame.agendamentoNumero}</strong>?`,
                async () => this.$nextTick().then(() => this.$refs.ModalAgendamentoExameLaboratorial.open())
            )
        },
    },
    props: {
        data: { type: Object, required: true },
        itemsNotRealizados: { type: Array, required: true }
    },
}
</script>

<style scoped>
.rkm-list-group-item {
    padding: 0.75rem 1.25rem;
}
.rkm-list-group-item:focus {
    outline: none;
}
.rkm-list-group-item:first-child {
    border-radius: 0;
}
.rkm-list-group-item:last-child {
    border-radius: 0;
}
.rkm-list-group-item > .row {
    margin: 0;
}
.rkm-collapse {
    border-bottom: 1px solid rgba(0, 0, 0, .15);
    border-left: 1px solid rgba(0, 0, 0, .15);
    border-right: 1px solid rgba(0, 0, 0, .15);
}
.font-13 {
    font-size: 13px!important;
}
h4 {
    font-size: 20px!important;
    font-weight: 600!important;
}
</style>